module.exports = __webpack_public_path__ + "static/img/img_IPmin_3.9aa21be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand/img_IPmin_3.png
// module id = 3nyM
// module chunks = 0